import assign from 'lodash/assign'; // @ts-ignore

var getInitConfigStore = function getInitConfigStore() {
  return {// initC7nUiConfig: () => {
    //   const c7nUiConfig = require('hzero-front/lib/utils/c7nUiConfig');
    //   if (c7nUiConfig.loadConfig) {
    //     c7nUiConfig.loadConfig();
    //   }
    // },
  };
};
export var getConfigStore = function getConfigStore() {
  var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (init || !window._hzeroConfigStore) {
    window._hzeroConfigStore = getInitConfigStore();
  }
  return window._hzeroConfigStore;
};
export var getConfig = function getConfig(key) {
  return getConfigStore()[key];
};
export var overWriteConfig = function overWriteConfig(config) {
  var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var oldConfig = getConfigStore(init);
  var newConfig = assign({}, oldConfig, config);
  if (config.dvaAppInit) {
    var oldDvaAppInit = oldConfig.dvaAppInit;
    newConfig.dvaAppInit = function (dvaApp) {
      oldDvaAppInit && oldDvaAppInit(dvaApp);
      config.dvaAppInit(dvaApp);
    };
  }
  window._hzeroConfigStore = newConfig;
  return getConfigStore();
};